import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import image3 from "../assets/Gemini_Generated_Image_r4ryltr4ryltr4ry (1).png";

/**
 * Add On Features Section Card
 * 
 * Content card for grid layout (no image, image is in right column)
 */
const AddOnFeaturesSection = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "24px",
          sm: "32px",
          md: "40px",
        },
        backgroundColor: "transparent",
        borderRadius: "16px",
        height: "100%",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: { xs: "24px", md: "32px" },
        alignItems: "center",
        transition: "all 0.3s ease",
      }}
    >
      {/* Left side - Image */}
      <Box
        sx={{
          flex: { xs: "none", md: "0 0 40%" },
          width: { xs: "100%", md: "auto" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={image3}
          alt="Add On Features"
          sx={{
            width: "100%",
            maxWidth: { xs: "100%", md: "523px" },
            height: { xs: "330px", md: "396px" },
            objectFit: "cover",
            borderRadius: "16px",
            border: "4px solid rgba(53, 103, 214, 0.25)",
            boxShadow: "0 4px 16px rgba(53, 103, 214, 0.15)",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: "0 8px 24px rgba(53, 103, 214, 0.25)",
              borderColor: "rgba(53, 103, 214, 0.4)",
            },
          }}
        />
      </Box>

      {/* Right side - Content */}
      <Box
        sx={{
          flex: { xs: "none", md: "1" },
          width: { xs: "100%", md: "auto" },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "24px", sm: "32px", md: "36px" },
            fontWeight: 700,
            fontFamily: "'Poppins', sans-serif",
            color: "#3567D6",
            marginBottom: { xs: "16px", md: "20px" },
          }}
        >
          Add On Features
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            color: "#64748b",
            lineHeight: 1.7,
            marginBottom: { xs: "24px", md: "32px" },
          }}
        >
          It is a long established fact that a reader will be distracted by the readable content.
        </Typography>

        {/* Features List */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: "20px", md: "24px" },
          }}
        >
          {/* Trend Report Feature */}
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
                marginBottom: "8px",
              }}
            >
              <CheckCircleIcon
                sx={{
                  color: "#3567D6",
                  fontSize: { xs: "20px", md: "22px" },
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "17px" },
                  color: "#022674",
                  fontWeight: 600,
                  lineHeight: 1.5,
                }}
              >
                Trend Report
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "15px" },
                color: "#64748b",
                lineHeight: 1.6,
                paddingLeft: { xs: "32px", md: "34px" },
              }}
            >
              Visual statistical test comparisons with year over year graphs and trends over time tracking
            </Typography>
          </Box>

          {/* Language Options Feature */}
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
                marginBottom: "8px",
              }}
            >
              <CheckCircleIcon
                sx={{
                  color: "#3567D6",
                  fontSize: { xs: "20px", md: "22px" },
                  marginTop: "2px",
                  flexShrink: 0,
                }}
              />
              <Typography
                sx={{
                  fontSize: { xs: "16px", md: "17px" },
                  color: "#022674",
                  fontWeight: 600,
                  lineHeight: 1.5,
                }}
              >
                Language Options Features
              </Typography>
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "15px" },
                color: "#64748b",
                lineHeight: 1.6,
                paddingLeft: { xs: "32px", md: "34px" },
              }}
            >
              Reports available in multiple easy to understand languages
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AddOnFeaturesSection;

